import { render, staticRenderFns } from "./ProjectSiteHistoricalUpdates.vue?vue&type=template&id=c465d1fe"
import script from "./ProjectSiteHistoricalUpdates.vue?vue&type=script&lang=js"
export * from "./ProjectSiteHistoricalUpdates.vue?vue&type=script&lang=js"
import style0 from "./ProjectSiteHistoricalUpdates.vue?vue&type=style&index=0&id=c465d1fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports